import { List } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const ListIcon = createLucideIcon(List);
